import {
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  Unit_instanceat14thlj150z as Unit_instance,
  last1vo29oleiqj36 as last,
  dropLast1vpiyky649o34 as dropLast,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  copyToArray2j022khrow2yi as copyToArray,
  createThis2j2avj17cvnv2 as createThis,
  lazy2hsh8ze7j6ikd as lazy,
  toList383f556t1dixk as toList,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  until1jbpn0z3f8lbg as until,
  Companion_getInstance1krakgr3yg44t as Companion_getInstance,
  toLongw1zpgk99d84b as toLong,
  Long2qws0ah9gnpki as Long,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  KtList3hktaavzmj137 as KtList,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  substringBeforeLastqh7oeuvefdek as substringBeforeLast,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  decodeToString1x4faah2liw2p as decodeToString,
  lines3g90sq0zeq43v as lines,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  substringBefore3n7kj60w69hju as substringBefore,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  removePrefix279df90bhrqqg as removePrefix,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  startsWith26w8qjqapeeq6 as startsWith,
  printStackTrace18lnx7a39cni as printStackTrace,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  toList3jhuyej2anx2q as toList_0,
  listOf1jh22dvmctj1r as listOf,
  endsWith3cq61xxngobwh as endsWith,
  asSequence2phdjljfh9jhx as asSequence,
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  plus2l6bq32n2wlna as plus,
  contains3ue2qo8xhmpf1 as contains,
  numberToLong1a4cndvg6c52s as numberToLong,
  isNumberiramasdbon0i as isNumber,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOfNotNull1v4ggfackvuny as listOfNotNull,
  plus310ted5e4i90h as plus_0,
  to2cs3ny02qtbcb as to,
  toString30pk9tzaqopn as toString_0,
  println2shhhgwwt4c61 as println,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  getKClass1s3j9wy1cofik as getKClass,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  first58ocm7j58k3q as first,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  DenoPointerpb0vypijx63v as DenoPointer,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_0,
  toLong12oqfsfu42e35 as toLong_0,
  toJsBigInt2lj477tra3oly as toJsBigInt,
  get_pointerlkbwhoqlhapz as get_pointer,
  jsObjectr1r5ao37ef4f as jsObject,
  NativeImageRefqizti6jm75 as NativeImageRef,
  get_Deno_isDeno1rvz34wr12yh3 as get_Deno_isDeno,
  toArray1y3va21vj7n9x as toArray,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  Deferred6wjx2us769ee as Deferred,
  asDeferredzhtizu7g12ut as asDeferred,
} from './kotlinx-coroutines-core.mjs';
import { Buffer25z94vsj0kb1s as Buffer } from './korlibs-memory-root-korlibs-memory.mjs';
import {
  get__low2jkzjjmu5faql as get__low,
  get__high277ao55jnazw7 as get__high,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.s2t_1 = get_FFI_SUPPORTED();
  }
  t2t(type) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.nf();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.Companion.extractTypeFunc.<anonymous>' call
      var tmp$ret$0 = item.np_1;
      destination.h(tmp$ret$0);
    }
    var generics = destination;
    var ret = last(generics);
    var params = dropLast(generics, 1);
    return new FuncType(params, ret);
  }
}
class FuncDelegate {
  constructor(base, bname, name, type, config, required) {
    this.u2t_1 = base;
    this.v2t_1 = bname;
    this.w2t_1 = name;
    this.x2t_1 = type;
    this.y2t_1 = config;
    this.z2t_1 = required;
    this.a2u_1 = Companion_getInstance_1().t2t(this.x2t_1);
    this.b2u_1 = this.a2u_1.g2u_1;
    this.c2u_1 = this.a2u_1.h2u_1;
    this.d2u_1 = null;
  }
  i2u(thisRef, property) {
    if (this.d2u_1 == null)
      this.d2u_1 = this.u2t_1.o2u().p2u(this.v2t_1, this.x2t_1);
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.d2u_1;
  }
  zn(thisRef, property) {
    return this.i2u(thisRef instanceof FFILib ? thisRef : THROW_CCE(), property);
  }
}
class FuncInfo {
  constructor(type, extraName, config, required) {
    required = required === VOID ? true : required;
    this.q2u_1 = type;
    this.r2u_1 = extraName;
    this.s2u_1 = config;
    this.t2u_1 = required;
  }
  u2u(thisRef, prop) {
    // Inline function 'kotlin.also' call
    var tmp = prop.callableName;
    var tmp0_elvis_lhs = this.r2u_1;
    var this_0 = new FuncDelegate(thisRef, tmp, tmp0_elvis_lhs == null ? prop.callableName : tmp0_elvis_lhs, this.q2u_1, this.s2u_1, this.t2u_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.ffi.FuncInfo.provideDelegate.<anonymous>' call
    thisRef.m2u_1.h(this_0);
    if (!thisRef.k2u_1) {
      this_0.i2u(thisRef, prop);
    }
    return this_0;
  }
}
class FFILib {
  static z2u(paths, lazyCreate) {
    Companion_getInstance_1();
    lazyCreate = lazyCreate === VOID ? true : lazyCreate;
    var $this = createThis(this);
    $this.j2u_1 = paths;
    $this.k2u_1 = lazyCreate;
    var tmp = $this;
    tmp.l2u_1 = lazy(FFILib$resolvedPath$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.m2u_1 = ArrayList.i1();
    $this.n2u_1 = null;
    return $this;
  }
  a2v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l2u_1;
    resolvedPath$factory();
    return this_0.o1();
  }
  static b2v(paths, lazyCreate) {
    Companion_getInstance_1();
    lazyCreate = lazyCreate === VOID ? true : lazyCreate;
    return this.z2u(filterNotNull(toList(paths)), lazyCreate);
  }
  c2v() {
    return FFILibSym_0(this);
  }
  o2u() {
    if (this.n2u_1 == null)
      this.n2u_1 = this.c2v();
    return ensureNotNull(this.n2u_1);
  }
  y5() {
    this.o2u().y5();
  }
}
class FFIPointerArray {
  f1(index) {
    // Inline function 'korlibs.memory.fromLowHigh' call
    Companion_getInstance();
    var low = this.d2v_1[imul(index, 2) + 0 | 0];
    var high = this.d2v_1[imul(index, 2) + 1 | 0];
    var address = toLong(low).c4(new Long(-1, 0)).d4(toLong(high).z3(32));
    if (address.equals(new Long(0, 0)))
      return null;
    // Inline function 'korlibs.ffi.FFIPointer' call
    return CreateFFIPointer(address);
  }
  d1() {
    return this.d2v_1.length / 2 | 0;
  }
  g1() {
    return this.d1() === 0;
  }
  a1() {
    return _get_vlist__9y3qo3(this).a1();
  }
  u2() {
    return _get_vlist__9y3qo3(this).u2();
  }
  v2(index) {
    return _get_vlist__9y3qo3(this).v2(index);
  }
  w2(fromIndex, toIndex) {
    throw NotImplementedError.nd();
  }
  e2v(element) {
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.f1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  f2v(elements) {
    return _get_vlist__9y3qo3(this).t2(elements);
  }
  t2(elements) {
    return this.f2v(elements);
  }
  g2v(element) {
    return this.e2v(element) >= 0;
  }
  k1(element) {
    if (!(element == null ? true : element instanceof DenoPointer))
      return false;
    return this.g2v((element == null ? true : element instanceof DenoPointer) ? element : THROW_CCE());
  }
  toString() {
    return 'FFIPointerArray(data=' + toString(this.d2v_1) + ')';
  }
  hashCode() {
    return hashCode(this.d2v_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FFIPointerArray))
      return false;
    var tmp0_other_with_cast = other instanceof FFIPointerArray ? other : THROW_CCE();
    if (!equals(this.d2v_1, tmp0_other_with_cast.d2v_1))
      return false;
    return true;
  }
}
class FFILibSym {}
function get(name, type) {
  throw NotImplementedError.nd();
}
function close() {
}
class FuncType {
  constructor(params, ret) {
    this.e2u_1 = params;
    this.f2u_1 = ret;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.e2u_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.FuncType.paramsClass.<anonymous>' call
      var tmp$ret$0 = item == null ? null : item.mf();
      destination.h(tmp$ret$0);
    }
    tmp.g2u_1 = destination;
    var tmp_0 = this;
    var tmp1_safe_receiver = this.f2u_1;
    tmp_0.h2u_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mf();
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.h2v_1 = new FFIFuncConfig();
    this.i2v_1 = this.h2v_1.l2v(true);
  }
}
class FFIFuncConfig {
  constructor(wideString, altAbiConvention) {
    Companion_getInstance_2();
    wideString = wideString === VOID ? false : wideString;
    altAbiConvention = altAbiConvention === VOID ? false : altAbiConvention;
    this.j2v_1 = wideString;
    this.k2v_1 = altAbiConvention;
  }
  m2v(wideString, altAbiConvention) {
    return new FFIFuncConfig(wideString, altAbiConvention);
  }
  l2v(wideString, altAbiConvention, $super) {
    wideString = wideString === VOID ? this.j2v_1 : wideString;
    altAbiConvention = altAbiConvention === VOID ? this.k2v_1 : altAbiConvention;
    return $super === VOID ? this.m2v(wideString, altAbiConvention) : $super.m2v.call(this, wideString, altAbiConvention);
  }
  toString() {
    return 'FFIFuncConfig(wideString=' + this.j2v_1 + ', altAbiConvention=' + this.k2v_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.j2v_1);
    result = imul(result, 31) + getBooleanHashCode(this.k2v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FFIFuncConfig))
      return false;
    var tmp0_other_with_cast = other instanceof FFIFuncConfig ? other : THROW_CCE();
    if (!(this.j2v_1 === tmp0_other_with_cast.j2v_1))
      return false;
    if (!(this.k2v_1 === tmp0_other_with_cast.k2v_1))
      return false;
    return true;
  }
}
class FFISyncIOFile {
  constructor(impl, fullPath) {
    this.n2v_1 = impl;
    this.o2v_1 = fullPath;
  }
  m22() {
    return substringBeforeLast(this.o2v_1, _Char___init__impl__6a9atx(47), '');
  }
  l3() {
    return substringAfterLast(this.o2v_1, _Char___init__impl__6a9atx(47));
  }
  n24() {
    return new FFISyncIOFile(this.n2v_1, this.m22());
  }
  p2v() {
    return this.n2v_1.q2v(this.o2v_1);
  }
  r2v() {
    return this.n2v_1.s2v(this.o2v_1);
  }
  t2v() {
    return decodeToString(this.n2v_1.u2v(this.o2v_1));
  }
  v2v() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.n2v_1.w2v(this.o2v_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.FFISyncIOFile.list.<anonymous>' call
      var tmp$ret$0 = this.xh(item);
      destination.h(tmp$ret$0);
    }
    return destination;
  }
  xh(child) {
    return new FFISyncIOFile(this.n2v_1, this.o2v_1 + '/' + child);
  }
}
class LDLibraries {
  constructor(fs) {
    Companion_getInstance_3();
    this.x2v_1 = fs;
    this.y2v_1 = LinkedHashSet.h1();
    this.z2v_1 = LinkedHashSet.h1();
    var tmp = this;
    tmp.a2w_1 = lazy(LDLibraries$libFoldersInitializeOnce$delegate$lambda(this));
  }
  b2w() {
    return toList_0(_get_libFoldersInitializeOnce__sla0ii(this));
  }
  c2w(path) {
    var file_0 = file(this.x2v_1, path);
    if (file_0.r2v()) {
      this.y2v_1.h(file_0);
    }
  }
}
class Companion_1 extends LDLibraries {
  constructor() {
    Companion_instance_1 = null;
    super(get_FFIPlatformSyncIO());
    Companion_instance_1 = this;
  }
}
class LibraryResolver {
  constructor(fs, platform) {
    Companion_getInstance_4();
    this.v2u_1 = fs;
    this.w2u_1 = platform;
    var tmp = this;
    tmp.x2u_1 = lazy(LibraryResolver$ldLibraries$delegate$lambda(this));
  }
  d2w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x2u_1;
    ldLibraries$factory();
    return this_0.o1();
  }
  y2u(names) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var inductionVariable = 0;
      var last = names.length;
      while (inductionVariable < last) {
        var element = names[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
        var result = this.e2w(element);
        if (!(result == null)) {
          tmp$ret$1 = result;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  e2w(name) {
    if (endsWith(name, '.dylib') || endsWith(name, '.so') || endsWith(name, '.dll')) {
      return name;
    }
    var tmp;
    if (this.w2u_1.y1e()) {
      var bases = listOf(['/Library/Frameworks', '/System/Library/Frameworks']);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
        var tmp0_iterator = bases.a1();
        while (tmp0_iterator.b1()) {
          var element = tmp0_iterator.c1();
          // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
          var base = element + '/' + name + '.framework';
          var tmp_0;
          if (file(this.v2u_1, base).r2v()) {
            tmp_0 = base + '/' + name;
          } else {
            tmp_0 = null;
          }
          var result = tmp_0;
          if (!(result == null)) {
            tmp$ret$1 = result;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    } else if (this.w2u_1.w1e()) {
      var tmp$ret$9;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = listOf([name, name + '.dll', '../' + name + '.dll', '../../' + name + '.dll', '../../../' + name + '.dll', 'C:/WINDOWS/SYSTEM32/' + name + '.dll']);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator_0 = this_0.a1();
        while (tmp0_iterator_0.b1()) {
          var item = tmp0_iterator_0.c1();
          // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
          var tmp$ret$2 = file(this.v2u_1, item);
          destination.h(tmp$ret$2);
        }
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList.i1();
        var tmp0_iterator_1 = destination.a1();
        while (tmp0_iterator_1.b1()) {
          var element_0 = tmp0_iterator_1.c1();
          // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
          if (element_0.p2v()) {
            destination_0.h(element_0);
          }
        }
        var tmp0_iterator_2 = destination_0.a1();
        while (tmp0_iterator_2.b1()) {
          var element_1 = tmp0_iterator_2.c1();
          // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
          var result_0 = element_1.o2v_1;
          if (!(result_0 == null)) {
            tmp$ret$9 = result_0;
            break $l$block_0;
          }
        }
        tmp$ret$9 = null;
      }
      tmp = tmp$ret$9;
    } else {
      var tmp_1 = asSequence(this.d2w().b2w());
      var tmp_2 = mapNotNull(tmp_1, LibraryResolver$resolve$lambda(name));
      var tmp_3 = asSequence(this.d2w().b2w());
      var exactFiles = plus(tmp_2, mapNotNull(tmp_3, LibraryResolver$resolve$lambda_0(name)));
      var tmp$ret$11;
      $l$block_2: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var tmp0_iterator_3 = exactFiles.a1();
        while (tmp0_iterator_3.b1()) {
          var element_2 = tmp0_iterator_3.c1();
          var tmp$ret$10;
          $l$block_1: {
            // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>' call
            if (Companion_getInstance_0().a1f().o1e()) {
              if (contains(element_2, 'i386')) {
                tmp$ret$10 = false;
                break $l$block_1;
              }
            }
            tmp$ret$10 = true;
          }
          if (tmp$ret$10) {
            tmp$ret$11 = element_2;
            break $l$block_2;
          }
        }
        tmp$ret$11 = null;
      }
      tmp = tmp$ret$11;
    }
    return tmp;
  }
}
class Companion_2 extends LibraryResolver {
  constructor() {
    Companion_instance_2 = null;
    super(get_FFIPlatformSyncIO(), Companion_getInstance_0());
    Companion_instance_2 = this;
  }
}
class FFILibSymJS {
  constructor(lib) {
    this.f2w_1 = lib;
    var tmp = this;
    tmp.g2w_1 = lazy(FFILibSymJS$symbolsByName$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.h2w_1 = lazy(FFILibSymJS$dylib$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.i2w_1 = lazy(FFILibSymJS$syms$delegate$lambda(this));
    this.j2w_1 = false;
  }
  l2w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g2w_1;
    symbolsByName$factory();
    return this_0.o1();
  }
  k2w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h2w_1;
    dylib$factory();
    return this_0.o1();
  }
  m2w() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i2w_1;
    syms$factory();
    return this_0.o1();
  }
  p2u(name, type) {
    if (this.m2w() == null) {
      // Inline function 'kotlin.error' call
      var tmp = toString(getKClassFromExpression(this.f2w_1));
      var tmp_0 = this.f2w_1;
      var message = "Can't get symbol '" + name + "' for " + tmp + " : '" + toString((tmp_0 instanceof FFILib ? tmp_0 : THROW_CCE()).j2u_1) + "'";
      throw IllegalStateException.s4(toString(message));
    }
    var sym = ensureNotNull(this.l2w().d3(name));
    return preprocessFunc(sym.x2t_1, this.m2w()[name], name, sym.y2t_1);
  }
  y5() {
    if (this.j2w_1)
      return Unit_instance;
    this.k2w().close();
    this.j2w_1 = true;
  }
}
class FFIPlatformSyncIO$1 {
  q2v(path) {
    var tmp;
    try {
      Deno.statSync(path);
      tmp = true;
    } catch ($p) {
      var tmp_0;
      var e = $p;
      tmp_0 = false;
      tmp = tmp_0;
    }
    return tmp;
  }
  s2v(path) {
    var tmp;
    try {
      tmp = Deno.statSync(path).isDirectory;
    } catch ($p) {
      var tmp_0;
      var e = $p;
      tmp_0 = false;
      tmp = tmp_0;
    }
    return tmp;
  }
  u2v(path) {
    return Deno.readFileSync(path);
  }
  w2v(path) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = toList(toArray(Deno.readDirSync(path)));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.<no name provided>.listFiles.<anonymous>' call
      var tmp$ret$0 = item.name;
      destination.h(tmp$ret$0);
    }
    return destination;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function FFILib$resolvedPath$delegate$lambda(this$0) {
  return function () {
    var tmp = Companion_getInstance_4();
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this$0.j2u_1;
    var tmp$ret$0 = copyToArray(this_0);
    return tmp.y2u(tmp$ret$0.slice());
  };
}
function _get_vlist__9y3qo3($this) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, $this.d1());
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.y1_1;
  var last = this_0.z1_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.ffi.FFIPointerArray.<get-vlist>.<anonymous>' call
      var it = item;
      var tmp$ret$0 = $this.f1(it);
      destination.h(tmp$ret$0);
    }
     while (!(item === last));
  return destination;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function setFFIPointer(_this__u8e3s4, value, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  if (get_FFI_POINTER_SIZE() === 8) {
    set64(_this__u8e3s4, get_address(value), byteOffset);
  } else {
    set32(_this__u8e3s4, get_address(value).f2(), byteOffset);
  }
}
function resolvedPath$factory() {
  return getPropertyCallableRef('resolvedPath', 1, KProperty1, function (receiver) {
    return receiver.a2v();
  }, null);
}
function file(_this__u8e3s4, fullPath) {
  return new FFISyncIOFile(_this__u8e3s4, fullPath);
}
var Companion_instance_1;
function Companion_getInstance_3() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function _get_libFoldersInitializeOnce__sla0ii($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.a2w_1;
  libFoldersInitializeOnce$factory();
  return this_0.o1();
}
function loadConfFile($this, file_0) {
  if ($this.z2v_1.k1(file_0))
    return Unit_instance;
  $this.z2v_1.h(file_0);
  var _iterator__ex2g4s = lines(file_0.t2v()).a1();
  $l$loop: while (_iterator__ex2g4s.b1()) {
    var line = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.takeIf' call
    // Inline function 'kotlin.text.trim' call
    var tmp$ret$0 = toString(trim(isCharSequence(line) ? line : THROW_CCE()));
    var this_0 = substringBefore(tmp$ret$0, _Char___init__impl__6a9atx(35));
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.ffi.LDLibraries.loadConfFile.<anonymous>' call
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_0) > 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tline = tmp_0;
    if (startsWith(tline, 'include ')) {
      var glob = removePrefix(tline, 'include ');
      var fullFile = file($this.x2v_1, glob);
      var globFolder = fullFile.n24();
      var globPattern = Regex.lh('^' + replace(replace(replace(fullFile.l3(), '.', '\\.'), '*', '.*'), '?', '.') + '$');
      if (globFolder.r2v()) {
        var _iterator__ex2g4s_0 = globFolder.v2v().a1();
        while (_iterator__ex2g4s_0.b1()) {
          var item = _iterator__ex2g4s_0.c1();
          if (globPattern.mh(item.l3())) {
            loadConfFile($this, item);
          }
        }
      }
    } else {
      $this.c2w(tline);
    }
  }
}
function LDLibraries$libFoldersInitializeOnce$delegate$lambda(this$0) {
  return function () {
    var tmp;
    try {
      this$0.c2w('/lib');
      this$0.c2w('/usr/lib');
      loadConfFile(this$0, file(this$0.x2v_1, '/etc/ld.so.conf'));
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return this$0.y2v_1;
  };
}
function libFoldersInitializeOnce$factory() {
  return getPropertyCallableRef('libFoldersInitializeOnce', 1, KProperty1, function (receiver) {
    return _get_libFoldersInitializeOnce__sla0ii(receiver);
  }, null);
}
var Companion_instance_2;
function Companion_getInstance_4() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
function LibraryResolver$ldLibraries$delegate$lambda(this$0) {
  return function () {
    return new LDLibraries(this$0.v2u_1);
  };
}
function LibraryResolver$resolve$lambda($name) {
  return function (folder) {
    var tries = listOf(['lib' + $name + '.so', $name]);
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var tmp0_iterator = tries.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.takeIf' call
        var this_0 = folder.xh(element);
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>.<anonymous>.<anonymous>' call
        if (this_0.p2v()) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var result = tmp;
        if (!(result == null)) {
          tmp$ret$3 = result;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp9_safe_receiver = tmp$ret$3;
    return tmp9_safe_receiver == null ? null : tmp9_safe_receiver.o2v_1;
  };
}
function LibraryResolver$resolve$lambda_0($name) {
  return function (folder) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = folder.v2v().a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.ffi.LibraryResolver.resolve.<anonymous>.<anonymous>' call
        if (startsWith(element.l3(), 'lib' + $name) || startsWith(element.l3(), $name)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp10_safe_receiver = tmp$ret$1;
    return tmp10_safe_receiver == null ? null : tmp10_safe_receiver.o2v_1;
  };
}
function ldLibraries$factory() {
  return getPropertyCallableRef('ldLibraries', 1, KProperty1, function (receiver) {
    return receiver.d2w();
  }, null);
}
function get_FFI_POINTER_SIZE() {
  _init_properties_FFILib_js_kt__tqmrqh();
  return FFI_POINTER_SIZE;
}
var FFI_POINTER_SIZE;
function get_FFI_SUPPORTED() {
  _init_properties_FFILib_js_kt__tqmrqh();
  return FFI_SUPPORTED;
}
var FFI_SUPPORTED;
function getS32(_this__u8e3s4, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  _init_properties_FFILib_js_kt__tqmrqh();
  return (new Deno.UnsafePointerView(_this__u8e3s4.w1f_1)).getInt32(byteOffset);
}
function FFILibSym_0(lib) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return new FFILibSymJS(lib);
}
function get_address(_this__u8e3s4) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var tmp = Deno.UnsafePointer;
  var res = tmp.value(_this__u8e3s4 == null ? null : _this__u8e3s4.w1f_1);
  var tmp_0;
  if (isNumber(res)) {
    tmp_0 = numberToLong(res);
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp_0 = toLong_0(res);
  }
  return tmp_0;
}
function CreateFFIPointer(ptr) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return ptr.equals(new Long(0, 0)) ? null : get_pointer(Deno.UnsafePointer.create(toJsBigInt(ptr)));
}
function FFILibSymJS$symbolsByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.f2w_1.m2u_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.ffi.FFILibSymJS.symbolsByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.v2t_1;
      destination.f3(tmp$ret$0, element);
    }
    return destination;
  };
}
function FFILibSymJS$dylib$delegate$lambda(this$0) {
  return function () {
    var tmp = this$0.f2w_1;
    if (!(tmp instanceof FFILib))
      THROW_CCE();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$5;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var tmp0_iterator = plus_0(listOfNotNull(this$0.f2w_1.a2v()), this$0.f2w_1.j2u_1).a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.ffi.FFILibSymJS.dylib$delegate.<anonymous>.<anonymous>' call
        var tmp_0;
        try {
          var tmp_1 = Deno;
          // Inline function 'kotlin.collections.toTypedArray' call
          // Inline function 'kotlin.collections.map' call
          var this_0 = this$0.f2w_1.m2u_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
          var tmp0_iterator_0 = this_0.a1();
          while (tmp0_iterator_0.b1()) {
            var item = tmp0_iterator_0.c1();
            // Inline function 'korlibs.ffi.FFILibSymJS.dylib$delegate.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$0 = to(item.v2t_1, funcToDenoDef(item.x2t_1));
            destination.h(tmp$ret$0);
          }
          var tmp$ret$3 = copyToArray(destination);
          tmp_0 = tmp_1.dlopen(element, jsObject(tmp$ret$3.slice()));
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_2;
        }
        var result = tmp_0;
        if (!(result == null)) {
          tmp$ret$5 = result;
          break $l$block;
        }
      }
      tmp$ret$5 = null;
    }
    // Inline function 'kotlin.js.asDynamic' call
    var this_1 = tmp$ret$5;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.ffi.FFILibSymJS.dylib$delegate.<anonymous>.<anonymous>' call
    if (this_1 == null) {
      println("Couldn't load library: dymlib=" + toString_0(this_1) + ' : ' + this$0.f2w_1.a2v());
    }
    return this_1;
  };
}
function FFILibSymJS$syms$delegate$lambda(this$0) {
  return function () {
    var tmp7_safe_receiver = this$0.k2w();
    return tmp7_safe_receiver == null ? null : tmp7_safe_receiver.symbols;
  };
}
function funcToDenoDef(_this__u8e3s4) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var ftype = Companion_getInstance_1().t2t(_this__u8e3s4);
  var tmp0_safe_receiver = ftype.f2u_1;
  var tmp = tmp0_safe_receiver == null ? null : toDenoFFI(tmp0_safe_receiver, true);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = ftype.e2u_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.ffi.funcToDenoDef.<anonymous>' call
    var tmp$ret$0 = item == null ? null : toDenoFFI(item, false);
    destination.h(tmp$ret$0);
  }
  var tmp$ret$3 = copyToArray(destination);
  return def(tmp, tmp$ret$3.slice(), equals(ftype.h2u_1, getKClass(Deferred)));
}
function preprocessFunc(type, func, name, config) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var ftype = Companion_getInstance_1().t2t(type);
  var convertToString = equals(ftype.h2u_1, PrimitiveClasses_getInstance().yf());
  var retPointer = equals(ftype.h2u_1, getKClass(DenoPointer));
  return preprocessFunc$lambda(ftype, func, convertToString, retPointer, name, type);
}
function def(result, params, nonblocking) {
  nonblocking = nonblocking === VOID ? false : nonblocking;
  _init_properties_FFILib_js_kt__tqmrqh();
  return jsObject([to('parameters', params), to('result', result), to('nonblocking', nonblocking)]);
}
function toDenoFFI(_this__u8e3s4, ret) {
  _init_properties_FFILib_js_kt__tqmrqh();
  if (equals(_this__u8e3s4.mf(), getKClass(Deferred))) {
    var tmp2_safe_receiver = first(_this__u8e3s4.nf()).np_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.mf();
    return tmp3_safe_receiver == null ? null : toDenoFFI_0(tmp3_safe_receiver, ret);
  } else {
    var tmp5_safe_receiver = _this__u8e3s4 == null ? null : _this__u8e3s4.mf();
    return tmp5_safe_receiver == null ? null : toDenoFFI_0(tmp5_safe_receiver, ret);
  }
}
function getCString(ptr) {
  _init_properties_FFILib_js_kt__tqmrqh();
  if (ptr == null)
    return null;
  return Deno.UnsafePointerView.getCString(ptr.w1f_1);
}
function toDenoFFI_0(_this__u8e3s4, ret) {
  _init_properties_FFILib_js_kt__tqmrqh();
  var tmp;
  if (equals(_this__u8e3s4, getKClass(Long))) {
    tmp = 'usize';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().uf())) {
    tmp = 'i32';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().vf())) {
    tmp = 'f32';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().wf())) {
    tmp = 'f64';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().rf())) {
    tmp = 'i8';
  } else if (equals(_this__u8e3s4, getKClass(NativeImageRef))) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().cg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().dg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().bg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().eg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().gg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().hg())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().ag())) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(FFIPointerArray))) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(Buffer))) {
    tmp = 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(DenoPointer))) {
    tmp = 'pointer';
  } else if (equals(_this__u8e3s4, PrimitiveClasses_getInstance().yf())) {
    tmp = ret ? 'pointer' : 'buffer';
  } else if (equals(_this__u8e3s4, getKClass(Unit))) {
    tmp = 'void';
  } else {
    var reason = toString(_this__u8e3s4);
    throw NotImplementedError.nd('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function CreateFFIMemory(size) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return new Uint8Array(size);
}
function get_pointer_0(_this__u8e3s4) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return get_pointer(Deno.UnsafePointer.of(new Int8Array(_this__u8e3s4.p1n_1.buffer, _this__u8e3s4.p1n_1.byteOffset, _this__u8e3s4.p1n_1.byteLength)));
}
function set32(_this__u8e3s4, value, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  _init_properties_FFILib_js_kt__tqmrqh();
  return getDataView(_this__u8e3s4, byteOffset, 4).setInt32(0, value, true);
}
function CreateFFIMemory_0(bytes) {
  _init_properties_FFILib_js_kt__tqmrqh();
  // Inline function 'kotlin.js.asDynamic' call
  return bytes;
}
function getDataView(_this__u8e3s4, offset, size) {
  _init_properties_FFILib_js_kt__tqmrqh();
  return new DataView((new Deno.UnsafePointerView(_this__u8e3s4.w1f_1)).getArrayBuffer(size, offset));
}
function set64(_this__u8e3s4, value, byteOffset) {
  byteOffset = byteOffset === VOID ? 0 : byteOffset;
  _init_properties_FFILib_js_kt__tqmrqh();
  set32(_this__u8e3s4, get__low(value), byteOffset);
  set32(_this__u8e3s4, get__high(value), byteOffset + 4 | 0);
}
function preprocessFunc$lambda($ftype, $func, $convertToString, $retPointer, $name, $type) {
  return function () {
    var arguments_0 = arguments;
    var params = $ftype.g2u_1;
    var inductionVariable = 0;
    var last = params.d1();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var param = params.f1(n);
        var v = arguments_0[n];
        if (equals(param, PrimitiveClasses_getInstance().yf())) {
          v = encodeToByteArray(toString(v) + '\x00');
        }
        if (v instanceof FFIPointerArray)
          v = v.d2v_1;
        if (v instanceof DenoPointer)
          v = v.w1f_1;
        if (v instanceof Buffer)
          v = v.p1n_1;
        if (!(v == null) ? typeof v === 'boolean' : false)
          v = v ? 1 : 0;
        if (v instanceof Long) {
          v = toJsBigInt(v instanceof Long ? v : THROW_CCE());
        }
        arguments_0[n] = v;
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    var tmp_0;
    try {
      var result = $func.apply(null, arguments_0);
      var tmp_1;
      if (result == null) {
        tmp_1 = null;
      } else if ($convertToString) {
        // Inline function 'kotlin.js.unsafeCast' call
        var ptr = result;
        tmp_1 = getCString(get_pointer(ptr));
      } else if ($retPointer) {
        // Inline function 'kotlin.js.unsafeCast' call
        tmp_1 = get_pointer(result);
      } else {
        tmp_1 = result;
      }
      var res2 = tmp_1;
      var tmp_2;
      if (res2 instanceof Promise) {
        // Inline function 'kotlin.js.unsafeCast' call
        tmp_2 = asDeferred(res2);
      } else {
        tmp_2 = res2;
      }
      tmp_0 = tmp_2;
    } catch ($p) {
      var tmp_3;
      var e = $p;
      println('ERROR calling[' + $name + ']: ' + toString($type) + ' : ' + toString(toList(Array.from(arguments_0))));
      throw e;
    }
    return tmp_0;
  };
}
function symbolsByName$factory() {
  return getPropertyCallableRef('symbolsByName', 1, KProperty1, function (receiver) {
    return receiver.l2w();
  }, null);
}
function dylib$factory() {
  return getPropertyCallableRef('dylib', 1, KProperty1, function (receiver) {
    return receiver.k2w();
  }, null);
}
function syms$factory() {
  return getPropertyCallableRef('syms', 1, KProperty1, function (receiver) {
    return receiver.m2w();
  }, null);
}
var properties_initialized_FFILib_js_kt_88mj2t;
function _init_properties_FFILib_js_kt__tqmrqh() {
  if (!properties_initialized_FFILib_js_kt_88mj2t) {
    properties_initialized_FFILib_js_kt_88mj2t = true;
    FFI_POINTER_SIZE = 8;
    FFI_SUPPORTED = get_Deno_isDeno();
  }
}
function get_FFIPlatformSyncIO() {
  _init_properties_FFIPlatformSyncIO_js_kt__byepuc();
  return FFIPlatformSyncIO;
}
var FFIPlatformSyncIO;
var properties_initialized_FFIPlatformSyncIO_js_kt_sxp582;
function _init_properties_FFIPlatformSyncIO_js_kt__byepuc() {
  if (!properties_initialized_FFIPlatformSyncIO_js_kt_sxp582) {
    properties_initialized_FFIPlatformSyncIO_js_kt_sxp582 = true;
    var tmp;
    if (get_Deno_isDeno()) {
      tmp = new FFIPlatformSyncIO$1();
    } else {
      throw NotImplementedError.nd();
    }
    FFIPlatformSyncIO = tmp;
  }
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(FuncDelegate, 'FuncDelegate');
initMetadataForClass(FuncInfo, 'FuncInfo');
initMetadataForClass(FFILib, 'FFILib', VOID, VOID, [AutoCloseable]);
initMetadataForClass(FFIPointerArray, 'FFIPointerArray', VOID, VOID, [KtList]);
initMetadataForInterface(FFILibSym, 'FFILibSym', VOID, VOID, [AutoCloseable]);
initMetadataForClass(FuncType, 'FuncType');
initMetadataForCompanion(Companion_0);
initMetadataForClass(FFIFuncConfig, 'FFIFuncConfig', FFIFuncConfig);
initMetadataForClass(FFISyncIOFile, 'FFISyncIOFile');
initMetadataForClass(LDLibraries, 'LDLibraries');
initMetadataForCompanion(Companion_1);
initMetadataForClass(LibraryResolver, 'LibraryResolver');
initMetadataForCompanion(Companion_2);
initMetadataForClass(FFILibSymJS, 'FFILibSymJS', VOID, VOID, [FFILibSym]);
initMetadataForClass(FFIPlatformSyncIO$1);
//endregion
//region block: exports
export {
  Companion_getInstance_2 as Companion_getInstance2ww1whxsubyyu,
  CreateFFIMemory as CreateFFIMemoryv82e6jbfcdze,
  CreateFFIMemory_0 as CreateFFIMemory2iekizxdvtyvt,
  CreateFFIPointer as CreateFFIPointernsr7ilwulbub,
  FuncInfo as FuncInfocud0a7bce10z,
  FFILib as FFILiby83bova0zjfy,
  getS32 as getS32284qh8a5ldxzn,
  get_pointer_0 as get_pointer2afz2rc14joly,
  set32 as set3216gyp8r69gas8,
  setFFIPointer as setFFIPointerjzarmbova4sm,
};
//endregion
